import React from "react";

import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { BiDotsHorizontalRounded } from "react-icons/bi";

const AxisSelectionTableCollapsableHeaders = ({
  title,
  length,
  updateFunction,
  defaultValue,
  expand,
  expandFunction,
  ...props
}) => {
  const getCollapsableHeaderContent = (length) => {
    const content = [];
    for (let i = 0; i < length - 1; i++) {
      content.push(
        <th className="px-0">
          <div className="flex items-center">
            <span className="text-sm invisible-element w-0">a</span>
            <hr className="bg-gray-500 h-0.1 flex-1" />
            {i === length - 2 && <span className="bg-gray-500 w-0.1 h-3" />}
          </div>
        </th>
      );
    }
    return content;
  };

  return (
    <>
      <th
        className="AxisSelectionTableCollapsableHeaders font-normal text-left pl-3 pr-0 text-gray-600"
        key="product-0-header"
        {...props}
      >
        <div className="flex items-center">
          <span className="text-sm whitespace-nowrap">{title}</span>
          <span className="mx-2 flex items-center">
            {expand && (
              <AiOutlineMinusCircle
                className="text-sm cursor-pointer"
                onClick={() => {
                  updateFunction(1);
                  expandFunction(false);
                }}
              />
            )}
            {!expand && (
              <AiOutlinePlusCircle
                className="text-sm cursor-pointer"
                onClick={() => {
                  updateFunction(defaultValue);
                  expandFunction(true);
                }}
              />
            )}
          </span>
          {!expand && <BiDotsHorizontalRounded className="text-xs text-gray-600" />}
          <hr className="bg-gray-400 h-0.1 flex-1" />
        </div>
      </th>
      {getCollapsableHeaderContent(length)}
    </>
  );
};

export default AxisSelectionTableCollapsableHeaders;
